/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Response shape. Omit for the full `SessionEventDto` graph; `calendar` for the flat `CalendarEventDto[]` projection (no nested session / exercise / profile data). Same start/end filter either way.
 * @export
 * @enum {string}
 */
export enum EnSessionEventView {
    Calendar = 'calendar'
}

